// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConceptBasicInformation_container__2iJ9q {
  background-color: var(--accent-color);
}

.ConceptBasicInformation_basic-information__6ikP1 {
  height: 40vh;
  display: flex !important;
  flex-direction: column;
  padding: 40px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 52px;
}
.ConceptBasicInformation_basic-information--title__ngxc3 {
  text-transform: uppercase;
  color: white;
  font-size: 52px;
  font-weight: 700;
  text-align: center;
}
.ConceptBasicInformation_basic-information--title__ngxc3 h1 {
  margin: 0;
  line-height: 1.2;
}
.ConceptBasicInformation_basic-information--definition__1is4t {
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  text-align: justify;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
}
@media only screen and (max-width: 480px) {
  .ConceptBasicInformation_basic-information__6ikP1 {
    height: auto;
  }
  .ConceptBasicInformation_basic-information--title__ngxc3 {
    font-size: 32px;
  }
  .ConceptBasicInformation_basic-information--definition__1is4t {
    font-size: 14px;
    line-height: 1.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/ConceptDetail/Components/BasicInformation/ConceptBasicInformation.module.scss"],"names":[],"mappings":"AAAA;EACE,qCAAA;AACF;;AAEA;EACE,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AACF;AACE;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AACI;EACE,SAAA;EACA,gBAAA;AACN;AAGE;EACE,+BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAIE;EAlCF;IAmCI,YAAA;EADF;EAGE;IACE,eAAA;EADJ;EAIE;IACE,eAAA;IACA,gBAAA;EAFJ;AACF","sourcesContent":[".container {\n  background-color: var(--accent-color);\n}\n\n.basic-information {\n  height: 40vh;\n  display: flex !important;\n  flex-direction: column;\n  padding: 40px;\n  justify-content: center;\n  align-items: center;\n  align-self: stretch;\n  gap: 52px;\n\n  &--title {\n    text-transform: uppercase;\n    color: white;\n    font-size: 52px;\n    font-weight: 700;\n    text-align: center;\n    \n    h1 {\n      margin: 0;\n      line-height: 1.2;\n    }\n  }\n\n  &--definition {\n    color: rgba(255, 255, 255, 0.7);\n    font-size: 16px;\n    text-align: justify;\n    display: -webkit-box;\n    -webkit-line-clamp: 7;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    cursor: pointer;\n  }\n\n  @media only screen and (max-width: 480px) {\n    height: auto;\n\n    &--title {\n      font-size: 32px;\n    }\n\n    &--definition {\n      font-size: 14px;\n      line-height: 1.5;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ConceptBasicInformation_container__2iJ9q`,
	"basic-information": `ConceptBasicInformation_basic-information__6ikP1`,
	"basic-information--title": `ConceptBasicInformation_basic-information--title__ngxc3`,
	"basic-information--definition": `ConceptBasicInformation_basic-information--definition__1is4t`
};
export default ___CSS_LOADER_EXPORT___;
